import React, { useContext } from 'react'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { StatusCard } from '@node-space/storybook-components/dist/StatusCard'
import { Text } from '@node-space/ui-components'
import { WalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { floorWithPrecision, numberWithCommas } from 'utils/utils'
import { convertFromWalletAtom, convertToWalletAtom, quoteAtom } from './atoms/atoms'

export const ConvertComplete = () => {
  const { t } = useTranslation()
  const [walletAction] = useContext(WalletActionContext)
  const convertFromWallet = useAtomValue(convertFromWalletAtom)
  const convertToWallet = useAtomValue(convertToWalletAtom)
  const quote = useAtomValue(quoteAtom)

  const handleNavigateClick = async () => {
    walletAction?.onClose()
  }

  return (
    <StatusCard
      testid="convert-success"
      headline={t('wallets.convert.completeStepHeader', {
        fromCurrency: convertFromWallet?.currency?.code,
        toCurrency: convertToWallet?.currency?.code,
        fromAmount: floorWithPrecision(quote.amountIn, convertFromWallet?.currency?.pricePrecision),
        toAmount: numberWithCommas(
          floorWithPrecision(quote?.amountOut, convertToWallet?.currency?.pricePrecision)
        ),
      })}
      borderless
      status="success"
      cardButton={{
        onClick: handleNavigateClick,
        name: t('done'),
        testid: 'done',
      }}
    >
      <Text isCentered>{t('wallets.convert.completeStepDescription')}</Text>
    </StatusCard>
  )
}
